import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {
  static targets = ["deleteLink", "editLink"];

  connect() {
    this.replaceElementWith      = this.replaceElementWith.bind(this);
    this.removeItemFromList      = this.removeItemFromList.bind(this);
    this.removeItemFromListMaybe = this.removeItemFromListMaybe.bind(this);
    App.Helpers.listenToCustomEvent(document, "checklist-item:delete-success", this.removeItemFromListMaybe);
    if (this.hasDeleteLinkTarget) {
      App.Helpers.addAjaxSuccessHandler(this.deleteLinkTarget, this.removeItemFromList);
    }
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "checklist-item:delete-success", this.removeItemFromListMaybe)
  }

  openEditFormMaybe(event) {
    const { listID } = event.detail;
    if (listID == this.listID && this.hasEditLinkTarget) {
      this.openInlineListItemForm({ target: this.editLinkTarget });
    }
  }

  openInlineListItemForm(event) {
    event && event.preventDefault && event.preventDefault();
    App.Helpers.ajaxRequest({ url: event.target.href, successHandler: this.replaceElementWith });
  }

  replaceElementWith(html) {
    if (!this.cancelEdit) {
      App.Helpers.replaceElement(this.element, html);
    }
    this.cancelEdit = false;
  }

  removeItemFromListMaybe({ detail }) {
    const { listItemID } = detail;
    if (listItemID == this.itemID) {
      this.removeItemFromList();
    }
  }

  removeItemFromList() {
    this.element.remove();
    document.dispatchEvent(createCustomEvent("checklists:items-update", this.element, { targetListID: this.listID }));
  }

  refreshListItem(event) {
    const { id } = event.detail;
    const url = this.detailsURL;
    if (url && id == this.itemID) {
      App.Helpers.ajaxRequest({ url, successHandler: this.replaceElementWith });
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get itemID() {
    return this.data.get("item-id")
  }

  get itemType() {
    return this.data.get("item-type")
  }

  get detailsURL() {
    return this.data.get("details-url");
  }

  get listID() {
    return this.data.get("list-id");
  }
};



// WEBPACK FOOTER //
// ./app/components/checklists/assets/javascript/checklists-list-item-controller.js